module.exports = __webpack_public_path__ + "static/media/icons-ic-nscb-status.4aa18728.svg";